import axios from 'axios';
import { API_URL } from 'projectConfig';
import { getAccessToken } from 'auth';
import CurrentUser from 'auth/currentUser';
import { get } from 'lodash';

export default async function downloadBulkCsvReport({
  bulkId,
  defaultFilename,
}: {
  bulkId: string;
  defaultFilename: string;
}) {
  if (!bulkId) {
    return;
  }
  const token = await getAccessToken();
  const accessToken = token?.accessToken || '';
  const locale = CurrentUser.getInstance().getLocale();
  if (!accessToken) {
    return;
  }
  const url = `${API_URL}/api/CompanyLists/${bulkId}/EsgReport`;
  const response = await axios({
    url,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + accessToken,
      'Accept-Language': locale,
    },
    responseType: 'blob', // important
  });
  // const contentDisposition = response.headers['Content-Disposition'];
  // const filename = contentDisposition ? contentDisposition.split('filename=')[1] : defaultFilename;
  const filename = defaultFilename;
  if (response.status === 200) {
    const blob = new Blob([response.data]);
    // Create blob link to download
    // IE10+ : (has Blob, but not a[download] or URL)
    const msSaveBlob = get(navigator, 'msSaveBlob') as
      | ((blob: Blob, filename: string) => void)
      | undefined;
    if (msSaveBlob) {
      msSaveBlob(blob, filename);
    } else {
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      // Force download
      link.click();
    }
  } else {
    const message = `Download failed: ${response.statusText}`;
    console.error(message);
  }
}
